import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';
import { Button } from 'src/common';
import { ITenderCat, TenderBlockSize, isFieldUrl } from 'src/models/procurements/Tender/types';
import { TenderCat, TenderSubCat } from 'src/shared';
import QAndABox from './QAndABox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsFromDottedLine, faArrowsToDottedLine, faExternalLink } from '@fortawesome/pro-light-svg-icons';
import { useToggle } from 'react-use';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import classNames from 'classnames';

export interface IProps {
  cat: ITenderCat;
}
export const CatQAndA: FC<IProps> = ({ cat }) => {
  const { subCats } = cat;
  const { t } = useTranslation();
  const [isExpanded, toggleIsExpanded] = useToggle(false);
  const { data } = useTenderData();
  const linkToQA = useMemo(
    () => (data?.linkToQA && isFieldUrl(data.linkToQA.firstField) ? data.linkToQA.firstField.url : undefined),
    [data]
  );

  return (
    <TenderCat cat={cat}>
      {!!subCats.length &&
        subCats.map(subCat => (
          <TenderSubCat
            subCat={subCat}
            key={subCat.id}
            actions={
              subCat.id === 'ADDITIONS_AND_QA.QUESTIONS_AND_ANSWERS' ? (
                <div className={styles.actions}>
                  <Button
                    type={'link'}
                    className={styles.action}
                    icon={
                      <FontAwesomeIcon
                        icon={!isExpanded ? faArrowsFromDottedLine : faArrowsToDottedLine}
                        className={styles.icon}
                      />
                    }
                    onClick={toggleIsExpanded}
                  >
                    {t(!isExpanded ? 'Common.expandAll' : 'Common.collapseAll')}
                  </Button>
                </div>
              ) : undefined
            }
            className={styles.content}
          >
            {!!subCat.boxes.length &&
              subCat.boxes.map((box, index) => (
                <QAndABox
                  box={box}
                  key={box.id}
                  index={index + 1}
                  expandable={subCat.id === 'ADDITIONS_AND_QA.QUESTIONS_AND_ANSWERS'}
                  size={TenderBlockSize.ThreeQuarters}
                  isExpanded={isExpanded}
                />
              ))}
          </TenderSubCat>
        ))}
      {!!linkToQA && (
        <div
          className={classNames(styles.linkWrap, {
            [styles.onlyLink]: !subCats.length
          })}
        >
          <a className={styles.link} rel="noopener noreferrer" target="_blank" href={linkToQA}>
            <FontAwesomeIcon icon={faExternalLink} className={styles.linkIcon} />
            <span>{t('DetailsPage.linkToQA')}</span>
          </a>
        </div>
      )}
    </TenderCat>
  );
};

export default CatQAndA;
